/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestItem } from './RequestItem';
import {
    RequestItemFromJSON,
    RequestItemFromJSONTyped,
    RequestItemToJSON,
    RequestItemToJSONTyped,
} from './RequestItem';

/**
 * 
 * @export
 * @interface ResponseFailed
 */
export interface ResponseFailed {
    /**
     * 
     * @type {string}
     * @memberof ResponseFailed
     */
    errMsg?: string;
    /**
     * 
     * @type {Array<RequestItem>}
     * @memberof ResponseFailed
     */
    items?: Array<RequestItem>;
    /**
     * 
     * @type {number}
     * @memberof ResponseFailed
     */
    userId?: number;
}

/**
 * Check if a given object implements the ResponseFailed interface.
 */
export function instanceOfResponseFailed(value: object): value is ResponseFailed {
    return true;
}

export function ResponseFailedFromJSON(json: any): ResponseFailed {
    return ResponseFailedFromJSONTyped(json, false);
}

export function ResponseFailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseFailed {
    if (json == null) {
        return json;
    }
    return {
        
        'errMsg': json['err_msg'] == null ? undefined : json['err_msg'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RequestItemFromJSON)),
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function ResponseFailedToJSON(json: any): ResponseFailed {
    return ResponseFailedToJSONTyped(json, false);
}

export function ResponseFailedToJSONTyped(value?: ResponseFailed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'err_msg': value['errMsg'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RequestItemToJSON)),
        'user_id': value['userId'],
    };
}

